<script>
import privateContacts from '../../components-manual/private/privateContacts.vue';
import CallbackPrivateV2 from '../../components-manual/private/CallbackPrivateV2.vue';
import PrivateTrustUs from '../../components-manual/private/PrivateTrustUs.vue';
import PrivateLifestyle from '../../components-manual/private/PrivateLifestyle.vue';
import PrivateInvestment from '../../components-manual/private/PrivateInvestment.vue';
import PrivateCard from '../../components-manual/private/PrivateCard.vue';
import PrivateProducts from '../../components-manual/private/PrivateProducts.vue';
import PrivateHero from '../../components-manual/private/PrivateHero.vue';
import FloatHeader from '../../components-manual/header/FloatHeader.vue';
import PrivatePageScroller from '../../components-manual/private/PrivatePageScroller.vue';
import UiTransitionViewport from '../../components-manual/ui/UiTransitionViewport.vue';

import '../../assets/scss/pages/private/private-banking.scss';

export default {
    components: {
        privateContacts,
        CallbackPrivateV2,
        PrivateTrustUs,
        PrivateLifestyle,
        PrivateInvestment,
        PrivateCard,
        PrivateProducts,
        PrivateHero,
        FloatHeader,
        PrivatePageScroller,
        UiTransitionViewport,
    },
};
</script>
